import { render } from "./GoalTask.vue?vue&type=template&id=4a66f10d"
import script from "./GoalTask.vue?vue&type=script&lang=js"
export * from "./GoalTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__